export default "__VITE_ASSET__BGtMB17N__"